<style scoped>
  .silder{background-color:#FFF;border-right:solid 1px #d7dde4;width:200px}
  .silder-item{text-align: left;padding-left:20px;height:60px;margin:0 20px;font-size:14px;line-height:60px;border-bottom:solid 1px #d7dde4;cursor: pointer;}
  .silder-item:hover{background-color:#f5fcff}
  .silder-item:hover .item-del-text{display:inline-block}
  .item-del-text{vertical-align: middle;text-align: center;color:#00a2e9;line-height:20px;display: none}
  .silder-title{height: 60px;color:#00a2e9;line-height:60px;margin:0 6px;padding:0 18px;font-size:14px;border-bottom:1px solid #d7dde4}
</style>
<template>
  <div>
    <Layout>
      <Sider hide-trigger class="silder">
        <div class="silder-title">业务范围</div>
        <div class="silder-item"
             style="padding:0;text-align: center"
             :style="item.id==search.projectType?'height:110px;line-height:110px;background-color:#f5fcff;':'height:110px;line-height:110px;'"
             v-for="(item,index) in projectTypeList"
             @click="search.projectType = item.id;search.causeType = '';search.modelType='';getCauseTypeList()"
        >
          {{item.name}}
        </div>
      </Sider>
      <Sider hide-trigger class="silder" style="width:300px;flex:0 0 300px;max-width:300px">
        <div class="silder-title">
          业务类型
          <span @click="edit.id='',edit.panel=true;edit.name='';edit.parentId=search.projectType;edit.typeName='causeType'" style="float: right;cursor: pointer;">
            <Icon type="md-add" />新增
          </span>
        </div>
        <div class="silder-item"
             :style="item.id==search.causeType?'background-color:#f5fcff;':''"
             v-for="(item,index) in causeTypeList"
        >
          <Row>
            <Col span="19">
              <div @click="search.causeType = item.id;search.modelType='';getModelTypeList()">
                <div style="line-height:1em;display: inline-block;vertical-align: middle;">{{item.name}}</div>
              </div>
            </Col>
            <Col span="5">
              <div class="item-del-text">
                <div @click="edit.id=item.id;edit.typeName='causeType';del()">删除</div>
                <div @click="edit.panel=true;edit.id=item.id;edit.name=item.name;edit.typeName='causeType';">重命名</div>
              </div>
            </Col>
          </Row>
        </div>
      </Sider>
      <Sider hide-trigger class="silder" style="width:400px;flex:0 0 400px;max-width:400px">
        <div class="silder-title">
          细分模板
          <span @click="edit.id='',edit.panel=true;edit.name='';edit.parentId=search.causeType;edit.typeName='modelType'" style="float: right;cursor: pointer;">
            <Icon type="md-add" />新增
          </span>
        </div>
        <div class="silder-item"
             :style="item.id==search.modelType?'background-color:#f5fcff;':''"
             v-for="(item,index) in modelTypeList"
        >
          <Row>
            <Col span="21">
              <div @click="search.modelType = item.id;getModelList()">
                <div style="line-height:1em;display: inline-block;vertical-align: middle;">{{item.name}}</div>
              </div>
            </Col>
            <Col span="3" @click="search.causeType = item.id;search.modelType='';getModelTypeList()">
              <div class="item-del-text">
                <div @click="edit.id=item.id;edit.typeName='modelType';del()">删除</div>
                <div @click="edit.panel=true;edit.id=item.id;edit.name=item.name;edit.typeName='modelType';">重命名</div>
              </div>
            </Col>
          </Row>
        </div>
      </Sider>
      <Layout>
        <Content style="background-color:#FFF">
          <div class="silder-title">
            委托方身份
            <span @click="edit.id='',edit.panel=true;edit.name='';edit.parentId=search.modelType;edit.typeName='model'" style="float: right;cursor: pointer;">
              <Icon type="md-add" />新增
            </span>
          </div>
          <div class="silder-item" v-for="(item,index) in modelList">
            <router-link :to="{name:'templateCreate',query:{id:item.id}}">
              <Col span="19">
                <p style="line-height:1em;display: inline-block;vertical-align: middle;">
                  {{item.name}}
                </p>
              </Col>
            </router-link>
            <Col span="5" @click="search.causeType = item.id;search.modelType='';getModelTypeList()">
              <div class="item-del-text">
                <div @click="edit.id=item.id;edit.typeName='model';del()">删除</div>
                <div @click="edit.panel=true;edit.id=item.id;edit.name=item.name;edit.typeName='model';">重命名</div>
              </div>
            </Col>
          </div>
        </Content>
      </Layout>
    </Layout>
    <div style="padding:10px"></div>
    <Modal
        v-model="edit.panel"
        title="新增分类"
        @on-ok="add()"
        ok-text="保存"
    >
      <Row type="flex" align="middle" style="padding: 20px 0">
        <Col span="6" style="text-align: right">输入类别名称：</Col>
        <Col span="16"><Input v-model="edit.name" placeholder="输入类别名称"></Input></Col>
      </Row>
    </Modal>
  </div>
</template>

<script>
  export default {
    name: "project",
    data:function(){
      return{
        edit:{
          panel:false,
          parentId:'',
          id:'',
          name:'',
          typeName:'',
        },
        search:{
          projectType:'',
          causeType:'',
          modelType:'',
        },
        projectTypeList:[],
        causeTypeList:[],
        modelTypeList:[],
        modelList:[],
      }
    },
    mounted:function () {
      this.getProjectTypeList()
    },
    methods:{
      //删除控制器
      del:function(){
        if(this.edit.typeName == 'causeType'){
          this.delCauseType()
        }
        if(this.edit.typeName=='modelType'){
          this.delModelType()
        }
        if(this.edit.typeName=='model'){
          this.delModel()
        }
      },
      //添加控制器
      add:function(){
        if(this.edit.typeName=='causeType'){
          if(this.edit.id){
            this.editCauseType()
          }else{
            this.addCauseType()
          }
        }
        if(this.edit.typeName=='modelType'){
          if(this.edit.id){
            this.editModelType()
          }else{
            this.addModelType()
          }
        }
        if(this.edit.typeName=='model'){
          if(this.edit.id){
            this.editModel()
          }else{
            this.addModel()
          }
        }
      },
      //编辑业务类型列表模板
      editCauseType:function(){
        var _this = this
        _this.send({
          headers:'A/EditAction',
          data:{
            CaseActionId:_this.edit.id,
            CaseActionTitle:_this.edit.name
          },
          success:function () {
            _this.getCauseTypeList()
            _this.$Notice.success({
              title:'系统消息',
              desc:'修改成功！'
            })
          }
        })
      },
      //编辑业务细分列表模板
      editModelType:function(){
        var _this = this
        _this.send({
          headers:'A/EditActionDetail',
          data:{
            CaseActionId:_this.edit.id,
            CaseActionTitle:_this.edit.name
          },
          success:function () {
            _this.getModelTypeList()
            _this.$Notice.success({
              title:'系统消息',
              desc:'修改成功！'
            })
          }
        })
      },
      //编辑模板名称
      editModel:function(){
        var _this = this
        _this.send({
          headers:'A/EditActionDetailTitle',
          data:{
            CaseActionDetailId:_this.edit.id,
            CaseActionDetailTitle:_this.edit.name
          },
          success:function () {
            _this.getModelTypeList()
            _this.$Notice.success({
              title:'系统消息',
              desc:'修改成功！'
            })
          }
        })
      },
      //删除业务类型列表模板
      delCauseType:function(){
        var _this = this
        _this.send({
          headers:'A/DeleteAction',
          confirm:true,
          data:{
            CaseActionId:_this.edit.id,
          },
          success:function () {
            _this.search.causeType = ''
            _this.getCauseTypeList()
            _this.$Notice.success({
              title:'系统消息',
              desc:'删除成功！'
            })
          }
        })
      },
      //删除业务细分列表模板
      delModelType:function(){
        var _this = this
        _this.send({
          headers:'A/DeleteActionDetail',
          confirm:true,
          data:{
            CaseActionId:_this.edit.id,
          },
          success:function () {
            _this.getModelTypeList()
            _this.$Notice.success({
              title:'系统消息',
              desc:'删除成功！'
            })
          }
        })
      },
      //删除模板
      delModel:function(){
        var _this = this
        _this.send({
          headers:'A/ActionDetailDelete',
          confirm:true,
          data:{
            CaseActionDetailId:_this.edit.id,
          },
          success:function () {
            _this.getCauseTypeList()
            _this.$Notice.success({
              title:'系统消息',
              desc:'删除成功！'
            })
          }
        })
      },
      //新增细分列表模板
      addModelType:function(){
        var _this = this
        _this.send({
          headers:'A/AddActionDetail',
          data:{
            CaseActionDetailTitle:_this.edit.name,
            CaseActionDetailId:_this.edit.parentId,
          },
          success:function () {
            _this.getModelTypeList()
            _this.$Notice.success({
              title:'系统消息',
              desc:'添加成功！'
            })
          }
        })
      },
      //新增业务类型列表模板
      addCauseType:function(){
        var _this = this
        _this.send({
          headers:'A/AddAction',
          data:{
            CaseActionTitle:_this.edit.name,
            CaseTypeId:_this.edit.parentId,
          },
          success:function () {
            _this.getCauseTypeList()
            _this.$Notice.success({
              title:'系统消息',
              desc:'添加成功！'
            })
          }
        })
      },
      //新建模板
      addModel:function(){
        var _this = this
        _this.send({
          headers:'A/ActionDetailModelAdd',
          data:{
            CaseActionDetailTitle:_this.edit.name,
            CaseActionId:_this.edit.parentId,
          },
          success:function () {
            _this.getCauseTypeList()
            _this.$Notice.success({
              title:'系统消息',
              desc:'添加成功！'
            })
          }
        })
      },
      //获取业务范围列表
      getProjectTypeList : function () {
        var _this = this
        _this.projectTypeList = []
        _this.send({
          headers:"C/CaseTypeList",
          success:function (res) {
            for(var index in res.TypeList){
              _this.projectTypeList.push({id:res.TypeList[index].CaseTypeId,name:res.TypeList[index].CaseTypeTitle})
            }
            if(_this.search.projectType==''){
              _this.search.projectType = _this.projectTypeList[0].id
            }
            _this.getCauseTypeList()
          }
        })
      },
      //获取业务类型列表
      getCauseTypeList:function () {
        var _this = this
        _this.causeTypeList = []
        _this.modelTypeList = []
        _this.modelList = []
        _this.send({
          headers: "A/ShowActionByType",
          data:{
            CaseTypeId:_this.search.projectType,
          },
          success:function (res) {
            for(var index in res){
              _this.causeTypeList.push({id:res[index].CaseActionId,name:res[index].CaseActionTitle})
            }
            if(_this.search.causeType==''){
              _this.search.causeType = _this.causeTypeList[0].id
            }
            _this.getModelTypeList()
          }
        })
      },
      //获取细分模板列表
      getModelTypeList:function(){
        var _this = this
        _this.modelTypeList = []
        _this.modelList = []
        _this.send({
          headers: "A/ShowDetailByAction ",
          data:{
            CaseActionId:_this.search.causeType,
          },
          success:function (res) {
            for(var index in res){
              _this.modelTypeList.push({id:res[index].CaseActionId,name:res[index].CaseActionTitle})
            }
            if(_this.search.modelType==''){
              _this.search.modelType = _this.modelTypeList[0].id
            }
            _this.getModelList()
          }
        })
      },
      //获取模板列表
      getModelList:function(){
        var _this = this
        _this.modelList = []
        _this.send({
          headers: "A/ShowModeByDetailList",
          data:{
            CaseActionId:_this.search.modelType,
          },
          success:function (res) {
            for(var index in res){
              _this.modelList.push({id:res[index].CaseActionDetailId,name:res[index].CaseActionDetailTitle})
            }
          }
        })
      },
    },
  }
</script>
